import { render, staticRenderFns } from "./MoneyStoreDetail.vue?vue&type=template&id=83095220&"
import script from "./MoneyStoreDetail.vue?vue&type=script&lang=js&"
export * from "./MoneyStoreDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports